import http from "../http-common";
import BaseService from "./base.service";

class EmploiCourseService extends BaseService {
  constructor() {
    super("emploi-course");
  }
  getByEmployer(id, params = {}) {
    return http.get(`${this.path}/getByEmployer/${id}`, { params });
  }
}

export default new EmploiCourseService();
